import React from 'react'
import styled from 'styled-components'

const TableColumnLabel = ({
  children,
  size = "md"
}) => {
  return (
    <ColumnLabel className={`table-column-label size-${size}`}>
      {children}
    </ColumnLabel>
  )
}

export default TableColumnLabel;

const ColumnLabel = styled.span`
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #656579;
  
  &.size-sm {
    font-size: 13px;
    font-weight: 500;
  }
`;


// WEBPACK FOOTER //
// ./src/components/ui/table-column-label.js